import { MAX_MESSAGE_TEXT_LENGTH } from './messageText';

// The live chat API refuses an upload with
// 400 { status: false, reason: 'upload_rejected', detail } (services-sure:
// sure_live_chat_api upload_guard), and a text over the length limit with
// 400 { status: false, reason: 'message_too_long' }. Sending it again cannot help,
// so such a message is 'rejected' and shows why, where any other failure is
// 'failed' and offers a Retry.
export const DELIVERED = { status: undefined };
export const FAILED = { status: 'failed' };

export const deliveryOutcome = (result) => {
  if (result?.status === true) return DELIVERED;
  if (result?.reason === 'upload_rejected') {
    return { status: 'rejected', rejection: result.detail || 'invalid_data' };
  }
  if (result?.reason === 'message_too_long') {
    return { status: 'rejected', rejection: 'message_too_long' };
  }
  return FAILED;
};

const NOUNS = { image: 'image', video: 'video', audio: 'recording', audio_message: 'recording' };
const SIZE_SETTINGS = { image: 'maxImageSize', video: 'maxVideoSize' };

const FIXED_TEXTS = {
  too_many_images: 'Too many images in one message',
  images_disabled: "Images can't be sent in this chat",
  files_disabled: "Files can't be sent in this chat",
  video_disabled: "Videos can't be sent in this chat",
  audio_disabled: "Voice messages can't be sent in this chat",
  message_too_long: `The message is longer than ${MAX_MESSAGE_TEXT_LENGTH} characters`,
};

export const rejectionText = (rejection, msg, settings) => {
  if (FIXED_TEXTS[rejection]) return FIXED_TEXTS[rejection];

  const noun = NOUNS[msg?.typeOfMedia] || 'file';
  switch (rejection) {
    case 'type_not_allowed':
      return `This ${noun} type isn't allowed here`;
    case 'type_mismatch':
      return `The ${noun} doesn't match its extension`;
    case 'too_large': {
      const limit = Number(settings?.[SIZE_SETTINGS[msg?.typeOfMedia] || 'maxFileSize']);
      return limit > 0 ? `The ${noun} is larger than ${limit} MB` : `The ${noun} is too large`;
    }
    case 'invalid_data':
      return `The ${noun} couldn't be read`;
    default:
      return `The ${noun} couldn't be sent`;
  }
};
